export const enum ApplicationRoute {
  Home = '/',
  Login = '/login',
  RequestResetPassword = '/reset-password',
  ResetPassword = '/reset-password/:token',
  TermsOfUse = '/terms-of-use',
  PrivacyPolicy = '/privacy-policy',
  Application = '/applications/:id',
  CompanyProfile = '/company-profile',
  Error = '/error',
  Other = '/*',
  SignUp = '/sign-up/:inviteToken/',
  ConfirmEmail = '/confirm-email',
  MyProfile = '/my-profile',
  UsersManagement = '/users-management',
  MdaPreview = '/master-dialer-agreement',
  CompanyNotifications = '/company-notifications',
  AccountStatus = '/account-status',
  RoleManagement = '/role-management',
  Prequalification = '/enroll',
  PrequalificationEntryFormResult = '/enroll/next-steps',
  PrequalificationRegistration = '/enroll/registration',
  PrequalificationThankYou = '/enroll/thank-you',
  PrequalificationExpiredSession = '/enroll/session-expired',
  PortalRegistration = '/portal-registration',
}
